import { render, staticRenderFns } from "./ModalImprimirHistorico.vue?vue&type=template&id=0cd518f1&"
import script from "./ModalImprimirHistorico.vue?vue&type=script&lang=js&"
export * from "./ModalImprimirHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports